import styled from '../../config/theme'

const Container = styled.div`
  border-radius: 5px;
  border: 1px solid ${props => props.theme.color.lightGray};
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  > * {
    margin: 5px 0;
  }

  > p:nth-last-of-type(1) {
    margin-bottom: 15px;
  }

  > button {
    margin-top: auto;
    margin-bottom: 0;
  }
`

export {
  Container,
}
